import { Box } from '@mui/material';
import { categoryPillSx } from 'component/Input/categoryPillStyles';

const CategoryButton = ({ text, onClick, selected }) => (
  <Box
    component="button"
    type="button"
    aria-pressed={selected}
    onClick={onClick}
    sx={categoryPillSx(selected)}
  >
    {text}
  </Box>
);

export default CategoryButton;
